<template>
  <div class="content">
    <b-breadcrumb>
      <b-breadcrumb-item active>Procesos</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="container">
      <div v-if="loading">
        <div id="loader">
          <font-awesome-icon icon="spinner" spin />
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div>
        <b-card no-body>
          <div class="p-4">
            <div class="row mb-1">
              <b-form-group label="Buscar" label-for="search-input" class="col-4">
                <b-input-group>
                  <b-form-input id="search-input" v-model="searchData" placeholder="Ingrese un término de búsqueda" />
                  <b-input-group-append>
                    <b-button class="orange-btn" :disabled="isTableBusy" @click="handleSearchData">Buscar</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="row">
              <div class="col-4" v-if="showSelects">
                <b-form-select
                  class="custom-select"
                  :options="optionsCatCorredurias"
                  :disabled="isTableBusy"
                  v-model="selectedCorreduria"
                >
                  <template #first>
                    <b-form-select-option :value="null">Corredurías...</b-form-select-option>
                  </template>
                </b-form-select>
              </div>
              <div class="col-4">
                <b-form-select
                  class="custom-select"
                  :options="optionsCatServicios"
                  :disabled="isTableBusy"
                  v-model="selectedProceso"
                >
                  <template #first>
                    <b-form-select-option :value="null">Procesos...</b-form-select-option>
                  </template>
                </b-form-select>
              </div>
              <div class="col-4">
                <b-form-select class="custom-select" :options="optionsStatus" :disabled="isTableBusy" v-model="selectedStatus">
                  <template #first>
                    <b-form-select-option :value="null">Estatus...</b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="text-center">
              <b-table
                class="mt-4"
                hover
                :fields="tableFields"
                :items="procesos"
                :busy="isTableBusy"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                @sort-changed="sortingChanged"
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando...</strong>
                  </div>
                </template>
                <template #cell(index)="{ index }">
                  {{ getIndex(index + 1) }}
                </template>
                <template #cell(acciones)="{ index, item }">
                  <b-row no-gutters class="d-flex flex-nowrap align-items-center">
                    <b-button class="btn orange-btn-border btn-sm editBtn" :to="getProcesoPath(item)">
                      <b-icon-pencil-fill />
                    </b-button>
                    <!-- <router-link class="btn orange-btn-border btn-sm mr-2" :to="{ path: getProcesoPath(item) }">
                      <b-icon-pencil />
                    </router-link> -->
                    <b-button
                      @click="editNotaProcesoHandler(index)"
                      size="sm"
                      v-b-tooltip.hover
                      title="Notas de trabajo"
                      class="editBtn"
                    >
                      <b-icon-journal-text />
                    </b-button>
                    <button
                      v-if="item.estatus === 'Iniciado' && [1, 2].includes(item.cat_servicios_id)"
                      v-b-tooltip.hover
                      title="Borrar proceso"
                      class="btn btn-danger btn-sm"
                      @click="deleteProcesoHandler(item)"
                    >
                      <b-icon-trash-fill />
                    </button>
                  </b-row>
                </template>
                <template #cell(listo)="{ item }">
                  <div v-if="item.estatus === 'Pagado'" class="circle completado_red">
                    <span class="number"><i class="fa fa-minus"></i></span>
                  </div>
                  <div v-else-if="item.estatus === 'Información Completada'" class="circle completado_red">
                    <span class="number"><i class="fa fa-minus"></i></span>
                  </div>
                  <div v-else-if="item.estatus === 'Finalizado'" class="circle completado_blue">
                    <span class="number"><i class="fa fa-check"></i></span>
                  </div>
                  <div v-else class="circle completado_yellow">
                    <span class="number"><i class="fa fa-minus"></i></span>
                  </div>
                </template>
              </b-table>
              <div class="d-flex my-2">
                <span>
                  Ordenado por:
                  <b>{{ sortBy }}</b>
                  , en dirección:
                  <b>{{ sortDesc ? "descendente" : "ascendente" }}</b>
                </span>
              </div>
              <div class="d-flex justify-content-between pages">
                <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalProcesos" />
                <span>Mostrando {{ procesos.length }} registros de {{ totalProcesos }}</span>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <b-modal no-close-on-backdrop centered hide-footer id="modal-notas-proceso" title="Notas de trabajo" size="lg">
      <div>
        <b-form-textarea id="textarea" v-model="currentNotaProceso.notas" rows="3" max-rows="8" no-resize></b-form-textarea>
        <p class="mt-2 info">{{ ultimaModificacionNotaProcesoComputed }}</p>
      </div>
      <b-button class="mt-3" variant="danger" @click="hideModalNotasProceso">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="guardarNotaProcesoHandler">Guardar</b-button>
    </b-modal>
  </div>
</template>

<script>
import { CorreduriasApi, EstatusApi, FuncionesApi, NotasProcesosApi } from "@/api";
import Storage from "@/utils/storage";

const storage = new Storage();

export default {
  name: "TasksStaff",

  components: {},

  created() {
    this.rol = storage.getItem("role");
    this.corredurias_id_log = Number(storage.getItem("corredurias_id"));

    if (this.corredurias_id_log !== 1) {
      this.selectedCorreduria = this.corredurias_id_log;
      this.clientes_id = 0;
    }

    this.getProcesos();
    this.getCatServicios();
    this.getCatCorredurias();
  },

  watch: {
    selectedCorreduria: function (val, oldVal) {
      if (val != oldVal) {
        this.getProcesos();
      }
    },
    selectedProceso: "getEstatus",
    selectedStatus: "getProcesos",
    currentPage: "getProcesos",
  },

  computed: {
    showSelects() {
      return this.corredurias_id_log == 1;
    },
    ultimaModificacionNotaProcesoComputed() {
      if (!this.currentNotaProceso.actualizado) {
        return "";
      }

      const date = new Date(this.currentNotaProceso.actualizado);
      date.setHours(date.getHours() - 6);
      const localDate = date.toLocaleString();

      return "Última modificación: " + localDate;
    },
  },

  mounted() {
    this.interval_id = setInterval(() => {
      if (this.isTableBusy) {
        return;
      }

      this.getProcesosSinLoader();
    }, 60000);
  },

  beforeDestroy() {
    this.clearInterval();
  },

  data() {
    return {
      tableFields: [
        { key: "index", label: "#", class: "text-center" },
        { key: "proceso", label: "Proceso", class: "text-center", sortable: true },
        { key: "folio", label: "Folio", class: "text-center", sortable: true },
        { key: "cliente", label: "Cliente", class: "text-center", sortable: true },
        { key: "descripcion", label: "Descripción", class: "text-center", sortable: true },
        { key: "creado", label: "Fecha creación", class: "text-center", sortable: true, sortDirection: "desc" },
        { key: "estatus", label: "Estatus", class: "text-center", sortable: true },
        { key: "correduria", label: "Correduría", class: "text-center", sortable: true },
        { key: "acciones", label: "Acciones", class: "text-center" },
        { key: "listo", label: "", class: "text-center" },
      ],

      interval_id: null,

      rol: null,
      corredurias_id_log: null,
      clientes_id: null,

      procesos: [],
      optionsCatCorredurias: [],
      optionsCatServicios: [],
      optionsStatus: [],

      searchData: null,
      selectedProceso: null,
      selectedStatus: null,
      selectedCorreduria: null,

      loading: false,

      // Table
      isTableBusy: false,
      currentPage: 1,
      perPage: 10,
      totalProcesos: 0,
      sortBy: "creado",
      sortDesc: true,
      sortDirection: "desc",
      total: 0,

      currentProcesoIndex: null,
      existsNotaProceso: false,
      currentNotaProceso: {
        id: null,
        creado: null,
        actualizado: null,
        activo: null,
        cat_servicio_id: null,
        proceso_id: null,
        notas: null,
      },
    };
  },

  methods: {
    getProcesoPath(item) {
      let proceso = "";

      if (item.cat_servicios_id == 6) {
        if (item.proceso === "Ratificación de firmas") {
          proceso = "ratificacion";
        } else {
          proceso = "ratificaciondigital";
        }
      } else {
        switch (item.cat_servicios_id) {
          case 1:
            proceso = "constitucion";
            break;
          case 2:
            proceso = "notificacion";
            break;
          case 3:
            proceso = "formalizacion";
            break;
          case 4:
            proceso = "cotejo";
            break;
        }
      }

      return `/dashboard/tasks/valid/${proceso}/${item.id}`;
    },

    clearInterval() {
      clearInterval(this.interval_id);
    },

    getIndex(index) {
      return index + (this.currentPage - 1) * this.perPage;
    },

    async handleSearchData() {
      await this.getProcesos();
    },

    async getProcesos() {
      try {
        this.isTableBusy = true;

        await this.getProcesosSinLoader();
      } catch (error) {
        console.log(error);
      } finally {
        this.isTableBusy = false;
      }
    },

    async getCatCorredurias() {
      try {
        const { value } = await CorreduriasApi.list({
          page: 0,
          registersPerPage: 0,
        });

        this.optionsCatCorredurias = value.map((o) => ({ text: o.nombre, value: o.id }));
      } catch (error) {
        console.log(error);
      }
    },

    async getCatServicios() {
      /*
      Trae la data que llena el select de procesos:
      DATA:
        "Constitución de sociedades",
        "Copias certificadas",
        "Formalización de actas",
        "Notificaciones",
        "Ratificación de firmas",
        "Ratificación de firmas digital",
      */
      try {
        const result = await EstatusApi.procesos({});
        this.optionsCatServicios = result;
      } catch (error) {
        console.log(error);
      }
    },

    async getEstatus() {
      /*
      Trae la data que llena el select de estatus,
      depende del proceso que se seleccione
      */
      try {
        this.optionsStatus = [];
        this.selectedStatus = null;

        this.getProcesosSinLoader();

        const { value } = await EstatusApi.list({
          page: 0,
          registersPerPage: 0,
          proceso: this.selectedProceso,
        });

        value.forEach((element) => {
          this.optionsStatus.push({ value: element.tipo, text: element.tipo });
        });
      } catch (error) {
        console.log(error);
      }
    },

    async getProcesosSinLoader() {
      try {
        let estatus = "Todos";

        if (this.selectedStatus) {
          estatus = this.selectedStatus;
        }

        const {
          odata_page: page,
          odata_total: total,
          odata_perpage: perPage,
          value,
        } = await FuncionesApi.procesos(estatus, {
          clientes_id: this.clientes_id,
          proceso: this.selectedProceso,
          page: this.currentPage,
          data: this.searchData,
          registersPerPage: this.perPage,
          corredurias_id: this.selectedCorreduria,
          sort: `${this.sortBy} ${this.sortDirection}`,
        });

        this.currentPage = page;
        this.totalProcesos = total;
        this.procesos = value;
      } catch (error) {
        console.log(error);
      }
    },

    async sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.currentPage = 1;
      this.sortDesc = ctx.sortDesc;
      this.sortDirection = ctx.sortDesc ? "DESC" : "ASC";
      this.isTableBusy = true;

      await this.getProcesos();
    },

    deleteProcesoHandler(item) {
      this.deleteProceso(item.cat_servicios_id, item.id);
    },

    async deleteProceso(cat_servicio_id, proceso_id) {
      try {
        this.loading = true;

        await FuncionesApi.deleteProcesoIniciado(cat_servicio_id, proceso_id);
        const index = this.procesos.findIndex((p) => p.cat_servicios_id === cat_servicio_id && p.id === proceso_id);

        if (index !== -1) {
          this.procesos.splice(index, 1);
        }

        this.$toast.success("Proceso eliminado con éxito.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } catch (error) {
        console.log(error);

        this.$toast.error("Ocurrió un error al procesar la solicitud.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    showModalNotasProceso() {
      this.$bvModal.show("modal-notas-proceso");
    },

    hideModalNotasProceso() {
      this.$bvModal.hide("modal-notas-proceso");
    },

    editNotaProcesoHandler(procesoIndex) {
      this.currentProcesoIndex = procesoIndex;
      this.editNotaProceso();
    },

    guardarNotaProcesoHandler() {
      this.guardarNotaProceso();
    },

    async editNotaProceso() {
      try {
        this.loading = true;

        const proceso = this.procesos[this.currentProcesoIndex];
        const { value } = await NotasProcesosApi.list({
          page: 0,
          registersPerPage: 0,
          catServicioId: proceso.cat_servicios_id,
          procesoId: proceso.id,
        });

        if (value.length === 0) {
          this.existsNotaProceso = false;
          this.currentNotaProceso = {
            id: null,
            creado: null,
            actualizado: null,
            activo: null,
            cat_servicio_id: proceso.cat_servicios_id,
            proceso_id: proceso.id,
            notas: null,
          };
        } else {
          this.existsNotaProceso = true;
          this.currentNotaProceso = value[value.length - 1];
        }

        this.showModalNotasProceso();
      } catch (error) {
        console.log(error);

        this.$toast.error("Error al cargar la información", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    async guardarNotaProceso() {
      try {
        this.loading = true;

        if (this.existsNotaProceso) {
          await NotasProcesosApi.edit(this.currentNotaProceso.id, this.currentNotaProceso);
        } else {
          const result = await NotasProcesosApi.create({
            cat_servicio_id: this.currentNotaProceso.cat_servicio_id,
            proceso_id: this.currentNotaProceso.proceso_id,
            notas: this.currentNotaProceso.notas,
          });

          this.currentNotaProceso = result;
        }

        this.$toast.success("Información guardada", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        this.hideModalNotasProceso();
      } catch (error) {
        console.log(error);

        this.$toast.error("Error al guardar la información", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    cancelEditNotaProceso() {
      this.hideModalNotasProceso();
    },
  },
};
</script>

<style scoped>
.custom-select {
  display: inline-block;
  width: 100%;
  height: 3rem;
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  border: 1px solid #e3e3e3;
  border-radius: 0.25rem;

  appearance: none;
}

a {
  color: #ea640b;
}

/* a:hover {
  color: #495057;
} */

.btn:hover {
  color: #ea640b;
}

a:focus {
  color: #ea640b;
}

.invi {
  display: none !important;
}

.completado_red {
  background-color: #e60505 !important;
}

.completado_yellow {
  background-color: #f7e00a !important;
}

.completado_blue {
  background-color: #0bbdea !important;
}

.circle {
  height: 20px;
  width: 20px;
  margin-top: 10px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: silver;
}

.icon-title {
  height: 20px;
  width: 20px;
  margin-top: 10px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.icon-title-fa {
  font-size: 11px;
  color: black;
}

.number {
  font-size: 11px;
  color: white;
}

.led-green {
  margin: 20px auto;
  width: 12px;
  height: 12px;
  background-color: #43eb34;
  /* #690 */
  border-radius: 50%;
  box-shadow:
    #257a1d 0 -1px 7px 1px,
    inset #460 0 -1px 9px,
    #7d0 0 2px 12px;
}

.led-red {
  margin: 20px auto;
  width: 12px;
  height: 12px;
  background-color: #e60505;
  border-radius: 50%;
  box-shadow:
    #a60903 0 -1px 7px 1px,
    inset #600 0 -1px 9px,
    #f00 0 2px 12px;
}

.led-yellow {
  margin: 20px auto;
  width: 12px;
  height: 12px;
  background-color: #f7e00a;
  border-radius: 50%;
  box-shadow:
    #d1ca04 0 -1px 7px 1px,
    inset #c4b206 0 -1px 9px,
    #dd0 0 2px 12px;
}
</style>
